import React, { useEffect, useRef, useState, ReactNode } from 'react';
import styled from 'styled-components';
import { NgCard, NgCardContent } from '../NgCard/NgCard';

interface StickyHeaderProps {
  children: ReactNode;
  top?: number;
  noWrapper?: boolean;
  zIndex?: number;
  noWrap?: boolean;
}

const StyledStickyWrapper = styled.div<{ $top: number; $isStuck: boolean; $noWrapper?: boolean; $zIndex: number }>`
  position: sticky;
  top: ${({ $top }) => `${$top}px`};
  z-index: ${({ $zIndex }) => $zIndex};
  width: 100%;

  ${({ $isStuck, $noWrapper, theme }) =>
    $isStuck &&
    !$noWrapper &&
    `
    width: calc(100% + ${theme.spacing.medium} * 2);
    margin-left: -${theme.spacing.medium};
    margin-right: -${theme.spacing.medium};
  `}
`;

export const StickyHeader: React.FC<StickyHeaderProps> = ({
  children,
  top = 120,
  noWrapper,
  zIndex = 1,
  noWrap = false,
}) => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const [isStuck, setIsStuck] = useState(false);

  useEffect(() => {
    if (!wrapperRef.current) return;

    const handleScroll = () => {
      if (!wrapperRef.current) return;
      const rect = wrapperRef.current.getBoundingClientRect();
      setIsStuck(rect.top <= top);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, [top]);

  if (noWrap) {
    return <>{children}</>;
  }

  return (
    <StyledStickyWrapper ref={wrapperRef} $top={top} $isStuck={isStuck} $noWrapper={noWrapper} $zIndex={zIndex}>
      {isStuck && !noWrapper ? (
        <NgCard>
          <NgCardContent>{children}</NgCardContent>
        </NgCard>
      ) : (
        children
      )}
    </StyledStickyWrapper>
  );
};
